<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue'
import {
  PopupBasicHeader,
  SelectIconCard,
  WepinTypes,
  colors,
  ToggleButton,
} from 'wepin-vue-component'
import { useI18nTypes } from '@/composables'
import { useSettingsStore } from '@/stores'

const emits = defineEmits<{
  (event: 'close'): void
}>()

const { t } = useI18nTypes()
const storage = useSettingsStore()

const cardSelectItems = ref<WepinTypes.SelectIconCardItemProps[]>([
  {
    id: 'card',
    element: {
      name: 'GridView',
      size: 'medium',
      color: colors.currentThemeRef.value.main,
    },
    text: t('change_layout.card'),
    isSelected: storage.accountLayout.card,
  },
  {
    id: 'list',
    element: {
      name: 'Hamburger',
      size: 'medium',
      color: colors.currentThemeRef.value.main,
    },
    text: t('change_layout.list'),
    isSelected: storage.accountLayout.list,
  },
])

watchEffect(() => {
  for (const item of cardSelectItems.value) {
    if (item.id === 'card') {
      storage.accountLayout.card = item.isSelected
    } else if (item.id === 'list') {
      storage.accountLayout.list = item.isSelected
    }
  }
})
const disabledGroup = computed(() => {
  return storage.accountLayout.card
})
</script>

<template>
  <div class="change-layout">
    <PopupBasicHeader
      :title="t('change_layout.title')"
      :exit="() => emits('close')"
    />
    <div class="card-select">
      <SelectIconCard v-model:items="cardSelectItems" />
    </div>
    <div v-if="!storage.accountLayout.card" class="group-mainnet">
      <span>
        {{ t('change_layout.group_mainnet') }}
      </span>
      <ToggleButton
        v-model:checked="storage.accountLayout.group"
        :disabled="disabledGroup"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'wepin-vue-component/src/styles/typeface.module.scss';

.change-layout {
  min-width: 360px;
  background-color: var(--grey_fff);
  border-radius: 8px;
  box-shadow: 0px 20px 10px rgba(0, 0, 0, 0.2);
  padding-bottom: 30px;
  .card-select {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .group-mainnet {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 30px 0 30px;

    > span {
      @include typeface('Paragraph_16_r');
    }
  }
}
</style>
